// Single home for the flags that put the console into platform's local-dev
// console mode (`just local-console`).  Each is DEV-gated so it can never take
// effect in a production build even if the env var leaks into one.

/**
 * Local-dev console mode (platform's `just local-console`): there's no Cognito,
 * so the Amplify sign-in is swapped for a local IdP flow (a trivial username
 * form that mints a real JWT; see LocalIdpLogin / getAuthToken).  Enabled by
 * VITE_DISABLE_AUTH=true, which `just local-console` sets.
 */
export function localDevEnabled(): boolean {
  return import.meta.env.DEV && import.meta.env.VITE_DISABLE_AUTH === "true";
}

/**
 * Skip the onboarding gate in local-dev: the stack rarely has an AWS account
 * seeded, so onboarding would otherwise trap every route on /onboarding (and
 * the wizard's Skip is client-only Relay state, lost on reload).  Enabled by
 * VITE_SKIP_ONBOARDING=true; set it false to exercise the onboarding flow.
 */
export function skipOnboardingForLocalDev(): boolean {
  return import.meta.env.DEV && import.meta.env.VITE_SKIP_ONBOARDING === "true";
}
